export default __webpack_public_path__ + "7dafe06160b25ae8006a07c642723fbe.png";